import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import "react-datepicker/dist/react-datepicker.css";
import { capitalizeFirstLetter } from "../../helpers";
import moment from "moment";
import { Wrapper, ScrollableContent, ModalHeader } from "../Styles/InputStyles";
import { ProfileSection } from "../Styles/PageStyles";
import { paidByOptions } from "../../Config";
import { FaRegBuilding } from "react-icons/fa";

const ViewCommissionModal = ({
  handleClose,
  selectedData,
  commissionData,
  setIsDealClouser,
}) => {
  const formatCurrency = (amt) => {
    if (!amt) return "0";
    return Number(amt).toLocaleString("en-IN");
  };

  const getPaidBy = (val) => {
    const found = paidByOptions.find((p) => p.value === val);
    return found ? found.label : "-";
  };

  const totalReceived = commissionData?.reduce((sum, item) => {
    return sum + Number(item.amount || 0);
  }, 0);
  const firstItem = commissionData?.length ? commissionData[0] : null;

  return (
    <Container>
      {/* HEADER */}
      <ModalHeader>
        <Title className="text-white">Commission Details</Title>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>

      <ProfileSection className="px-4 py-3 flex items-center justify-between">
        {/* Left: Icon + Info */}
        <div className="flex items-center gap-2">
          {/* Inventory Icon */}
          <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center">
            <FaRegBuilding className="text-gray-600" />
          </div>

          {/* Text Info */}
          <div className="flex flex-col">
            <p className="text-md font-medium text-gray-800">
              {capitalizeFirstLetter(selectedData?.inventoryName || "")}
            </p>
            <p className="text-xs text-gray-400">
              Inventory ID: #{firstItem?.inventoryId || "-"}
            </p>
          </div>
        </div>

        {/* Right: Budget */}
        <div className="text-right">
          <p className="text-xs text-gray-400">Total Received</p>
          <p className="text-lg font-bold text-green-600">
            ₹ {formatCurrency(totalReceived)}
          </p>
        </div>
      </ProfileSection>

      <Content>
        <ScrollableContent className="max-h-[calc(100vh-120px)] pb-4">
          {commissionData?.length > 0 ? (
            <Wrapper className="!gap-0 !mt-0">
              <SectionTitle>
                Payment Breakdown
                <button
                  onClick={() => setIsDealClouser(true)}
                  className="text-sm text-primary-color font-medium"
                >
                  + Add
                </button>
              </SectionTitle>

              <div className="mt-2 space-y-2 mb-8">
                {commissionData.map((item, index) => (
                  <div
                    key={index}
                    className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm hover:shadow-md transition"
                  >
                    {/* TOP ROW */}
                    <div className="flex items-center justify-between mb-3">
                      {/* Amount (Primary Focus) */}
                      <div>
                        <p className="text-xs text-gray-400">Amount</p>
                        <p className="text-lg font-semibold text-green-600">
                          ₹ {formatCurrency(item.amount)}
                        </p>
                      </div>

                      {/* Paid By Badge */}
                      <span className="text-xs px-2 py-1 rounded-full bg-blue-50 text-blue-600 font-medium">
                        {getPaidBy(item.commissionPaidBy)}
                      </span>
                    </div>

                    {/* INFO GRID */}
                    <div className="grid grid-cols-2 gap-3 text-sm">
                      <div>
                        <p className="text-gray-400 text-xs">Client</p>
                        <p className="text-gray-700 font-medium">
                          {capitalizeFirstLetter(item.name)}
                        </p>
                      </div>

                      <div className="text-right">
                        <p className="text-gray-400 text-xs">Date</p>
                        <p className="text-gray-700 font-medium">
                          {moment(item.createdAt).format("DD MMM YYYY")}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Wrapper>
          ) : (
            <div className="flex flex-col items-center justify-center h-[60vh] text-center">
              {/* Icon */}
              <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center mb-3">
                <FaRegBuilding className="text-gray-400 text-xl" />
              </div>

              {/* Title */}
              <p className="text-gray-700 font-medium text-sm mb-1">
                No commission records yet
              </p>

              {/* Subtitle */}
              <p className="text-gray-400 text-xs mb-4">
                Start by adding your first commission
              </p>

              {/* CTA Button */}
              <button
                onClick={() => setIsDealClouser(true)}
                className="bg-gradient-to-r from-primary-color to-teal-400 text-white px-5 py-2.5 rounded-lg text-sm font-medium shadow-sm hover:shadow-md transition"
              >
                + Add Commission
              </button>
            </div>
          )}
        </ScrollableContent>
      </Content>
    </Container>
  );
};

// Styled Components
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-600`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center mb-2`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;

export default ViewCommissionModal;
